var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptocurrency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cryptocurrency-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.9186 13.8933C10.7796 14.7208 9.40786 15.1665 8 15.1665C6.59214 15.1665 5.22041 14.7208 4.08143 13.8933M10.9225 2.50788C12.1878 3.12504 13.2254 4.12696 13.8863 5.37003C14.5473 6.61309 14.7977 8.0335 14.6018 9.42766M1.39828 9.42759C1.20234 8.03343 1.45279 6.61303 2.11375 5.36996C2.7747 4.12689 3.81221 3.12498 5.07759 2.50781M7.62287 4.87696L4.37712 8.12271C4.24512 8.25472 4.17911 8.32072 4.15438 8.39683C4.13263 8.46378 4.13263 8.5359 4.15438 8.60284C4.17911 8.67895 4.24512 8.74496 4.37712 8.87696L7.62287 12.1227C7.75488 12.2547 7.82088 12.3207 7.89699 12.3455C7.96394 12.3672 8.03606 12.3672 8.103 12.3455C8.17911 12.3207 8.24512 12.2547 8.37712 12.1227L11.6229 8.87696C11.7549 8.74496 11.8209 8.67895 11.8456 8.60284C11.8674 8.5359 11.8674 8.46378 11.8456 8.39683C11.8209 8.32072 11.7549 8.25472 11.6229 8.12272L8.37712 4.87696C8.24512 4.74496 8.17911 4.67895 8.103 4.65422C8.03606 4.63247 7.96394 4.63247 7.89699 4.65422C7.82088 4.67895 7.75488 4.74496 7.62287 4.87696Z",
    stroke: "#5A27DD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocurrency);
export default __webpack_public_path__ + "static/media/cryptocurrency.887cc78237ef4a7592fd4cd7d00c2d64.svg";
export { ForwardRef as ReactComponent };